import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useHigherEdOrgManagerQuery } from '@uplift/queries';
import {
  ChangePasswordForm, EditableSectionContainer, EditableSectionRow, useChangePasswordForm
} from '@uplift/ui-v2';

export type ManagerLoginSectionProps = {
  managerId: string;
};

export const ManagerLoginSection: React.VFC<ManagerLoginSectionProps> = ({ managerId }) => {
  const { classes } = useManagerLoginSectionStyles();
  const { data: manager } = useHigherEdOrgManagerQuery(managerId, { enabled: !!managerId, suspense: true });

  const { changePasswordFormik } = useChangePasswordForm(managerId);

  return (
    <EditableSectionContainer
      title="Login"
      rowDividers
      formikConfigs={{
        'password': changePasswordFormik,
      }}
    >
      <EditableSectionRow
        label="Account email"
        rowKey="email"
        kind="custom"
        testId="manager-email-row"
      >
        <Typography className={classes.email}>{manager?.user?.email}</Typography>
        <Typography variant="body2" className={classes.help}>Need to change? Contact oncampus@joinuplift.co</Typography>
      </EditableSectionRow>
      <EditableSectionRow
        label="Password"
        rowKey="password"
        editButtonText="Change"
        form={<ChangePasswordForm />}
        kind="editable-row"
        testId="manager-password-row"
      />
    </EditableSectionContainer>
  );
};

const useManagerLoginSectionStyles = makeStyles({ name: 'ManagerLoginSection' })(() => ({
  title: {
    fontWeight: 500,
    textTransform: 'capitalize',
    letterSpacing: '0.4px'
  },
  email: {
    fontWeight: 500,
    letterSpacing: '0.4px'
  },
  help: {
    letterSpacing: '0.4px',
  }
}));
